import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import isPropValid from '@emotion/is-prop-valid'

import { baseStyles } from './styles'

const SkeletonElement = styled('div', {
  shouldForwardProp: prop =>
    isPropValid(prop) && prop !== 'width' && prop !== 'height'
})(baseStyles)

const Skeleton = ({ width, height, rounded, center, ...rest }) => {
  return (
    <SkeletonElement
      width={width}
      height={height}
      rounded={rounded}
      center={center}
      {...rest}
    />
  )
}

Skeleton.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  rounded: PropTypes.bool,
  center: PropTypes.bool
}

Skeleton.defaultProps = {
  rounded: false,
  center: false
}

export default Skeleton
